<template>
  <base-input
    :type="accessKey ? 'text' : 'number'"
    v-model="code"
    ref="baseinput"
    :label="uniqueLabel ? uniqueLabel : `Código ${label}`"
    :valid="isValid"
    :mask="accessKey ? '' : '######'"
    :maxlength="accessKey ? '' : 6"
    @input="handleInput"
    @focus="onFocus()"
    @blur="`${!!blur && validate()}`"
    :design="`${!!design ? `${design}` : ''}`"
  />
</template>

<script>
import BaseInput from '@/components/Input';
import { baseEvents } from '@/mixins/baseEvents.js';

export default {
  mixins: [baseEvents],
  components: {
    BaseInput,
  },
  props: {
    label: { type: String, default: '' },
    uniqueLabel: { type: String, default: '' },
    accessKey: { type: Boolean, default: false },
    design: String,
    blur: { type: Boolean, default: true },
  },
  mounted() {
    this.inputId = this.$refs.baseinput.id;
  },
  data() {
    return {
      code: this.value || '',
      isValid: true,
      inputId: '',
    };
  },
  methods: {
    validate() {
      if (this.accessKey ? this.code.length !== 36 : this.code.length !== 6) {
        this.isValid = false;
        this.$parent.setErrorValidation(
          this.inputId,
          this.accessKey ? '8003' : '8001'
        );
      }
    },
    onFocus() {
      this.isValid = true;
      this.$parent.removeErrorValidation(this.inputId);
    },
    handleInput() {
      this.$emit('input', this.code);
    },
  },
};
</script>
